class StopEditingController {

    constructor($window, storeService, loginoutService) {
        this.$window = $window;
        this.storeService = storeService;
        this.loginoutService = loginoutService;
    }

    isEditing () {
        return !!this.storeService.get('reservation');
    }

    stopEditing () {
        return this.loginoutService.stopEditing().then(response => {
            this.$window.dispatchEvent(new CustomEvent('initCalendar'));
            this.guests = [];
            this.maybeRequestAvailability({ response: response });
        });
    }
}

StopEditingController.$inject = ['$window', 'storeService', 'loginoutService'];

export default StopEditingController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/controllers/stopEditing.controller.js